"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=wrapper.decl.js.map